import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "login-modal" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = {
  key: 0,
  class: "login-panel"
}
const _hoisted_4 = { class: "login-title" }
const _hoisted_5 = { class: "login-subtitle" }
const _hoisted_6 = { class: "login-form" }
const _hoisted_7 = { class: "form-item" }
const _hoisted_8 = { for: "email" }
const _hoisted_9 = { class: "form-item" }
const _hoisted_10 = { for: "password" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = {
  key: 0,
  class: "error-message"
}
const _hoisted_13 = { class: "login-switch" }
const _hoisted_14 = {
  key: 1,
  class: "login-panel"
}
const _hoisted_15 = { class: "login-title" }
const _hoisted_16 = { class: "login-subtitle" }
const _hoisted_17 = { class: "login-form" }
const _hoisted_18 = { class: "form-item" }
const _hoisted_19 = { for: "reg-email" }
const _hoisted_20 = { class: "form-item" }
const _hoisted_21 = { for: "reg-password" }
const _hoisted_22 = ["placeholder"]
const _hoisted_23 = { class: "form-item" }
const _hoisted_24 = { for: "reg-confirmPassword" }
const _hoisted_25 = ["placeholder"]
const _hoisted_26 = { class: "form-item" }
const _hoisted_27 = { for: "reg-captcha" }
const _hoisted_28 = { class: "captcha-container" }
const _hoisted_29 = ["placeholder"]
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  key: 0,
  class: "error-message"
}
const _hoisted_32 = { class: "login-switch" }
const _hoisted_33 = {
  key: 2,
  class: "login-panel"
}
const _hoisted_34 = { class: "login-title" }
const _hoisted_35 = { class: "login-subtitle" }
const _hoisted_36 = { class: "login-form" }
const _hoisted_37 = { class: "form-item" }
const _hoisted_38 = { for: "reset-email" }
const _hoisted_39 = { class: "form-item" }
const _hoisted_40 = { for: "reset-password" }
const _hoisted_41 = ["placeholder"]
const _hoisted_42 = { class: "form-item" }
const _hoisted_43 = { for: "reset-confirmPassword" }
const _hoisted_44 = ["placeholder"]
const _hoisted_45 = { class: "form-item" }
const _hoisted_46 = { for: "reset-captcha" }
const _hoisted_47 = { class: "captcha-container" }
const _hoisted_48 = ["placeholder"]
const _hoisted_49 = ["disabled"]
const _hoisted_50 = {
  key: 0,
  class: "error-message"
}
const _hoisted_51 = { class: "login-switch" }

import axios from 'axios';
import { ref, computed } from 'vue'
import { getInitialLang, Lang, t } from '@/i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  emits: ["close", "login"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const isRegister = ref(false)
const isForgotPassword = ref(false)
const email = ref('')
const password = ref('')
const confirmPassword = ref('')
const captcha = ref('')
const errorMsg = ref('')
const countdown = ref(0)

const validateEmail = (emailStr: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(emailStr)
}

const validateConfirmPassword = (): boolean => {
  if (!confirmPassword.value) {
    errorMsg.value = t('form.confirmPassword')
    return false
  }
  if (password.value !== confirmPassword.value) {
    errorMsg.value = t('form.passwordMismatch')
    return false
  }
  return true
}

const validateCaptcha = (length: number): boolean => {
  if (!captcha.value) {
    errorMsg.value = t('form.enterCaptcha')
    return false
  }
  if (captcha.value.length !== length) {
    errorMsg.value = `${t('form.captchaLength')}${length}${t('form.captchaDigits')}`
    return false
  }
  return true
}

const canSendCaptcha = computed(() => {
  return validateEmail(email.value) && email.value.trim() !== ''
})

const handleClose = () => {
  resetForm()
  emit('close')
}

const goRegister = () => {
  resetForm()
  isRegister.value = true
  isForgotPassword.value = false
}

const backToLogin = () => {
  resetForm()
  isRegister.value = false
  isForgotPassword.value = false
}

const toggleForgotPassword = () => {
  resetForm()
  isRegister.value = false
  isForgotPassword.value = true
}

const resetForm = () => {
  email.value = ''
  password.value = ''
  confirmPassword.value = ''
  captcha.value = ''
  errorMsg.value = ''
  countdown.value = 0
}

const startCountdown = () => {
  countdown.value = 60
  const timer = setInterval(() => {
    countdown.value--
    if (countdown.value <= 0) {
      clearInterval(timer)
    }
  }, 1000)
}

const sendRegisterCaptcha = async () => {
  if (!canSendCaptcha.value) {
    errorMsg.value = t('form.validEmail')
    return
  }

  const result = await axios.post('https://api.studying1v1.com/video/register/sentEmailCode', {
    email: email.value,
  })
  if (result.status === 200) {
    if (result.data.success) {
      alert(result.data.message)
    } else {
      errorMsg.value = result.data.msg
      alert(result.data.message)
      return
    }
  }
  console.log('发送注册验证码结果:', result)

  startCountdown()
}

const sendResetPasswordCaptcha = async () => {
  if (!canSendCaptcha.value) {
    errorMsg.value = t('form.validEmail')
    return
  }

  const result = await axios.post('https://api.studying1v1.com/video/resetPassword/sendEmailCode', {
    email: email.value,
  })
  if (result.status === 200) {
    if (result.data.success) {
      alert(result.data.message)
    } else {
      errorMsg.value = result.data.msg
      alert(result.data.message)
      return
    }
  }
  console.log('发送重置密码验证码结果:', result)

  startCountdown()
}

const lang = ref<Lang>(getInitialLang())

const handleRegister = async () => {
  if (!email.value.trim()) {
    errorMsg.value = t('form.enterEmail')
    return
  }
  if (!validateEmail(email.value)) {
    errorMsg.value = t('form.validEmail')
    return
  }
  if (!password.value) {
    errorMsg.value = t('form.enterPassword')
    return
  }
  if (password.value.length < 6) {
    errorMsg.value = t('form.passwordMin')
    return
  }
  if (!validateConfirmPassword()) return
  if (!validateCaptcha(6)) return
  errorMsg.value = ''

  const { default: md5 } = await import('md5')
  const result = await axios.post('https://api.studying1v1.com/video/register/register', {
    email: email.value,
    password: md5(password.value),
    captcha: captcha.value,
    lang: lang.value,
  })

  console.log('注册结果:', result)
  if (result.status === 200) {
    if (result.data.success) {
      alert(result.data.message)
      backToLogin()
    } else {
      errorMsg.value = result.data.msg
      alert(result.data.message)
    }
  }
}

const handleResetPassword = async () => {
  if (!email.value.trim()) {
    errorMsg.value = t('form.enterEmail')
    return
  }
  if (!validateEmail(email.value)) {
    errorMsg.value = t('form.validEmail')
    return
  }
  if (!password.value) {
    errorMsg.value = t('form.enterPassword')
    return
  }
  if (password.value.length < 6) {
    errorMsg.value = t('form.passwordMin')
    return
  }
  if (!validateConfirmPassword()) return
  if (!validateCaptcha(8)) return
  errorMsg.value = ''

  const { default: md5 } = await import('md5')

  const result = await axios.post('https://api.studying1v1.com/video/resetPassword/submit', {
    email: email.value,
    newPassword: md5(password.value),
    captcha: captcha.value,
  })

  console.log('修改密码结果:', result)
  if (result.status === 200) {
    if (result.data.success) {
      alert(result.data.message)
      backToLogin()
    } else {
      errorMsg.value = result.data.msg
      alert(result.data.message)
    }
  }
}

const handleLogin = async () => {
  if (!email.value.trim()) {
    errorMsg.value = t('form.enterEmail')
    return
  }
  if (!validateEmail(email.value)) {
    errorMsg.value = t('form.validEmail')
    return
  }
  if (!password.value) {
    errorMsg.value = t('form.enterPassword')
    return
  }
  if (password.value.length < 6) {
    errorMsg.value = t('form.passwordMin')
    return
  }
  errorMsg.value = ''

  const { default: md5 } = await import('md5')

  const result = await axios.post('https://api.studying1v1.com/video/login', {
    email: email.value,
    password: md5(password.value),
  })
  if (result.status === 200) {
    if (result.data.result) {
      localStorage.setItem('token', result.data.token)
      emit('login', email.value, password.value)
      window.gtag('event', 'loginFinish', { result: true })
    } else {
      errorMsg.value = result.data.msg
      alert(result.data.message)
    }
  }
  console.log('登录结果:', result)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "login-modal-overlay",
    onClick: _withModifiers(handleClose, ["self"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "close-btn",
        onClick: handleClose,
        "aria-label": _unref(t)('login.close')
      }, [...(_cache[10] || (_cache[10] = [
        _createElementVNode("svg", {
          width: "13",
          height: "13",
          viewBox: "0 0 18 18",
          fill: "none"
        }, [
          _createElementVNode("path", {
            d: "M3 3 L15 15 M15 3 L3 15",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round"
          })
        ], -1)
      ]))], 8, _hoisted_2),
      (!isRegister.value && !isForgotPassword.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "login-brand" }, [
              _createElementVNode("img", {
                src: "/favicon256.png",
                class: "brand-icon"
              })
            ], -1)),
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(t)('login.title')), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('login.subtitle')), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(t)('login.email')), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  id: "email",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                  placeholder: "your@email.com"
                }, null, 512), [
                  [_vModelText, email.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(t)('login.password')), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  id: "password",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                  placeholder: _unref(t)('login.passwordPlaceholder')
                }, null, 8, _hoisted_11), [
                  [_vModelText, password.value]
                ]),
                _createElementVNode("button", {
                  class: "forgot-link",
                  onClick: toggleForgotPassword
                }, _toDisplayString(_unref(t)('login.forgot')), 1)
              ]),
              (errorMsg.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(errorMsg.value), 1))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn-primary",
                onClick: handleLogin
              }, _toDisplayString(_unref(t)('login.submit')), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)('login.noAccount')), 1),
              _createElementVNode("button", {
                class: "switch-btn",
                onClick: goRegister
              }, _toDisplayString(_unref(t)('login.signup')), 1)
            ])
          ]))
        : (isRegister.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "login-brand" }, [
                _createElementVNode("img", {
                  src: "/favicon256.png",
                  class: "brand-icon"
                })
              ], -1)),
              _createElementVNode("h2", _hoisted_15, _toDisplayString(_unref(t)('register.title')), 1),
              _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(t)('register.subtitle')), 1),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_unref(t)('login.email')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    id: "reg-email",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((email).value = $event)),
                    placeholder: "your@email.com"
                  }, null, 512), [
                    [_vModelText, email.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("label", _hoisted_21, _toDisplayString(_unref(t)('login.password')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    id: "reg-password",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((password).value = $event)),
                    placeholder: _unref(t)('register.passwordPlaceholder')
                  }, null, 8, _hoisted_22), [
                    [_vModelText, password.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("label", _hoisted_24, _toDisplayString(_unref(t)('register.confirmPassword')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    id: "reg-confirmPassword",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((confirmPassword).value = $event)),
                    placeholder: _unref(t)('register.confirmPlaceholder')
                  }, null, 8, _hoisted_25), [
                    [_vModelText, confirmPassword.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("label", _hoisted_27, _toDisplayString(_unref(t)('register.captcha')), 1),
                  _createElementVNode("div", _hoisted_28, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "reg-captcha",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((captcha).value = $event)),
                      placeholder: _unref(t)('register.captchaPlaceholder6')
                    }, null, 8, _hoisted_29), [
                      [_vModelText, captcha.value]
                    ]),
                    _createElementVNode("button", {
                      class: "captcha-btn",
                      disabled: !canSendCaptcha.value || countdown.value > 0,
                      onClick: sendRegisterCaptcha
                    }, _toDisplayString(countdown.value > 0 ? `${countdown.value}${_unref(t)('register.resendIn')}` : _unref(t)('register.sendCode')), 9, _hoisted_30)
                  ])
                ]),
                (errorMsg.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(errorMsg.value), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "btn-primary",
                  onClick: handleRegister
                }, _toDisplayString(_unref(t)('register.submit')), 1)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('register.haveAccount')), 1),
                _createElementVNode("button", {
                  class: "switch-btn",
                  onClick: backToLogin
                }, _toDisplayString(_unref(t)('register.loginNow')), 1)
              ])
            ]))
          : (isForgotPassword.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "login-brand" }, [
                  _createElementVNode("img", {
                    src: "/favicon256.png",
                    class: "brand-icon"
                  })
                ], -1)),
                _createElementVNode("h2", _hoisted_34, _toDisplayString(_unref(t)('forgot.title')), 1),
                _createElementVNode("p", _hoisted_35, _toDisplayString(_unref(t)('forgot.subtitle')), 1),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("label", _hoisted_38, _toDisplayString(_unref(t)('login.email')), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      id: "reset-email",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((email).value = $event)),
                      placeholder: "your@email.com"
                    }, null, 512), [
                      [_vModelText, email.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("label", _hoisted_40, _toDisplayString(_unref(t)('forgot.newPassword')), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      id: "reset-password",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((password).value = $event)),
                      placeholder: _unref(t)('forgot.newPasswordPlaceholder')
                    }, null, 8, _hoisted_41), [
                      [_vModelText, password.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("label", _hoisted_43, _toDisplayString(_unref(t)('register.confirmPassword')), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      id: "reset-confirmPassword",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((confirmPassword).value = $event)),
                      placeholder: _unref(t)('register.confirmPlaceholder')
                    }, null, 8, _hoisted_44), [
                      [_vModelText, confirmPassword.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("label", _hoisted_46, _toDisplayString(_unref(t)('register.captcha')), 1),
                    _createElementVNode("div", _hoisted_47, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "reset-captcha",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((captcha).value = $event)),
                        placeholder: _unref(t)('register.captchaPlaceholder8')
                      }, null, 8, _hoisted_48), [
                        [_vModelText, captcha.value]
                      ]),
                      _createElementVNode("button", {
                        class: "captcha-btn",
                        disabled: !canSendCaptcha.value || countdown.value > 0,
                        onClick: sendResetPasswordCaptcha
                      }, _toDisplayString(countdown.value > 0 ? `${countdown.value}${_unref(t)('register.resendIn')}` : _unref(t)('register.sendCode')), 9, _hoisted_49)
                    ])
                  ]),
                  (errorMsg.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(errorMsg.value), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "btn-primary",
                    onClick: handleResetPassword
                  }, _toDisplayString(_unref(t)('forgot.submit')), 1)
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('forgot.remember')), 1),
                  _createElementVNode("button", {
                    class: "switch-btn",
                    onClick: backToLogin
                  }, _toDisplayString(_unref(t)('register.loginNow')), 1)
                ])
              ]))
            : _createCommentVNode("", true)
    ])
  ]))
}
}

})